import * as React from "react";
import { useState, useEffect } from "react";
import { MeiliSearch } from 'meilisearch'
import ModernCard from "../core/ModernCard";
import Button from "../core/Button";
import Loader from "../core/Loader"
import { toast } from "../../utils";



function Search(props){
  const [query, setQuery] = useState('')
  const [resources, setResources] = useState([])
  const [resourceCategories, setResourceCategories] = useState([])
  const [courses, setCourses] = useState([])
  const [quotes, setQuotes] = useState([])
  const [loading, setLoading] = useState(false)
  const [searched, setSearched] = useState(false)

  const client = new MeiliSearch({
    host: props.meilisearchUrl,
    apiKey: 'S49gaMiDZYR0y5b-dLTT6AtcbyBx6LNK74XON69J_kA',
  })


  async function search(){
    if(query.length < 3) {
      toast.error('query must be 3 characters or more')
      return
    }
    setResources([])
    setResourceCategories([])
    setCourses([])
    setQuotes([])
    setLoading(true)
    //resources
    const resources_index = client.index('Resource')
    const resources_result = await resources_index.search(query, {
      filter: 'hidden = false',
    })
    setResources(resources_result.hits)
    // console.log('resources hits', resources_result)

    //resource categories
    const resource_categories_index = client.index('ResourceCategory')
    const resource_categories_result = await resource_categories_index.search(query, {
      filter: 'hidden = false',
    })
    setResourceCategories(resource_categories_result.hits)
    // console.log('resource category hits', resource_categories_result)

    //courses 
    const courses_index = client.index('Library_Course')
    const courses_result = await courses_index.search(query, {
      filter: 'status = published AND hidden = false',
    })
    setCourses(courses_result.hits)
    // console.log('courses hits', courses_result)

    //quotes 
    const quotes_index = client.index('QuoteCalculator_Quote')
    const quotes_result = await quotes_index.search(query, {
      filter: `organization_id = ${props.userContext.organization.data.id} AND discarded_at IS NULL`
    })
    setQuotes(quotes_result.hits)
    // console.log('quotes hits', quotes_result)  
    // setTimeout(() => {
    //   setLoading(false)
    // }, 2000);
    setLoading(false)
    setSearched(true)
  } 


  return(
    <div className="container">
      <ModernCard>
        <div className="row">
          <div className="col-lg-4 col-lg-offset-4" style={{paddingTop:'40px', paddingBottom:'40px'}}>
            <img className="img-responsive" src="https://chartec-core-public.s3.us-west-1.amazonaws.com/core_logo_red.png"/>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12" style={{paddingTop:'40px', paddingBottom:'40px'}}>
            <div style={{display:'flex', justifyContent:'center', alignItems:'flex-end', flexDirection:'row'}}>
              <input 
                type="text" 
                value={query} 
                placeholder="Search Here..." 
                onChange={(e) => setQuery(e.target.value)} 
                style={{marginRight:'30px', marginBottom:'0px', width:'33%'}} 
                onKeyDown={(e) => {
                  if(e.keyCode == 13){
                    search()
                  }
                }}
              />
              <Button color="success" onClick={search} loading={loading}>Search</Button>
            </div>
          </div>
        </div>
        <div className="row text-left" style={{paddingTop:'30px'}}>
          <div className="col-lg-12">
            {loading && <Loader/>}
            {!loading && (
              <div>
                {resources.map((resource) => {
                  return (
                    <div key={resource.id}>
                      <a href={`/resources/${resource.id}`} target="_blank" rel="noopener noreferrer" style={{fontSize:'16px'}}>
                        <b>[Resource] </b>{resource.name}
                      </a>
                      {/* <p>{resource}</p> */}
                    </div>
                  )
                })}
                {resourceCategories.map((category) => {
                  return (
                    <div key={category.id}>
                      <a href={`/library?category=Sales&category_id=${category.id}&open_tab=resources`} target="_blank" rel="noopener noreferrer" style={{fontSize:'16px'}}>
                        <b>[Resource Category] </b>{category.name}
                      </a>
                    </div>
                  )
                })}
                {courses.map((course) => {
                  return (
                    <div key={course.id}>
                      <a href={`/library/courses/${course.id}`} target="_blank" rel="noopener noreferrer" style={{fontSize:'16px'}}>
                        <b>[Course] </b>{course.title}
                      </a>
                    </div>
                  )
                })}
                {quotes.map((quote) => {
                  return (
                    <div key={quote.id}>
                      <a href={`/quote_calculator/${quote.quote_calculator_quote_calculator_id}/quote_show/${quote.id}/`} target="_blank" rel="noopener noreferrer" style={{fontSize:'16px'}}>
                        <b>[Quote] </b>{quote.company}
                      </a>
                    </div>
                  )
                })}
              </div>
            )}
            {searched && (resources.length + resourceCategories.length + courses.length + quotes.length == 0) && (
              <div className="text-center">
                <p style={{color:'black', fontSize:'16px'}}>0 results found</p>
              </div>
            )}
          </div>
        </div>
      </ModernCard>
    </div>
  )
}

export default Search


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Search.tsx